import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { NavLink } from 'react-router-dom';

const SidebarLink = ({
  title, icon, newLink, route, onClick, openInNewTab,
}) => {
  // If openInNewTab is true, use a regular anchor tag
  if (openInNewTab) {
    return (
      <a
        href={route}
        onClick={onClick}
        target="_blank"
        rel="noopener noreferrer"
        className="sidebar__link-wrap"
      >
        <li className="sidebar__link">
          {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
          <p className="sidebar__link-title">
            {title}
            {newLink ? <Badge className="sidebar__link-badge"><span>New</span></Badge> : ''}
          </p>
        </li>
      </a>
    );
  }
  
  // Otherwise use NavLink for internal navigation
  return (
    <NavLink
      to={route}
      onClick={onClick}
      activeClassName="sidebar__link-active"
    >
      <li className="sidebar__link">
        {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
        <p className="sidebar__link-title">
          {title}
          {newLink ? <Badge className="sidebar__link-badge"><span>New</span></Badge> : ''}
        </p>
      </li>
    </NavLink>
  );
};

SidebarLink.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
  openInNewTab: PropTypes.bool,
};

SidebarLink.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
  onClick: () => {},
  openInNewTab: false,
};

export default SidebarLink;
